import { ActivityTraceabilityDTO } from '@behavior/activity/dto/ActivityTraceabilityDTO';
import { AssessorDTO } from '@behavior/activity/dto/AssessorDTO';
import { UserDTO } from '@behavior/init/dto/UserDTO';
import useUser from '@behavior/init/getUserV2';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';
import { TraceabilityState } from '@components/Activity/types/TraceabilityState';
import { backendDateFormat } from '@src/Dates';
import { useState } from 'react';
import moment from 'moment';

export const useTraceabilityState = () => {
  const {user} = useUser(); 
  const [traceability, setTraceability] = useState<ActivityTraceabilityDTO>();
  const [hseUnit, setHseUnit] = useState<UserDTO>();
  const [signatureDate, setSignatureDate] = useState<string>('');
  const [distributionList, setDistributionList] = useState<ContactDTO[]>([]);
  const defaultAssessor : AssessorDTO =  {
    person: user?.person,
    signatureDte: moment(new Date()).format(backendDateFormat)
  }; 
  const [assessorList, setAssessorList] = useState<AssessorDTO[]>([defaultAssessor]);

  return {
    hseUnit,
    setHseUnit,
    signatureDate,
    setSignatureDate,
    distributionList,
    setDistributionList,
    assessorList,
    setAssessorList,
    traceability,
    setTraceability,
  } as TraceabilityState;
};
